/**
 * Mocked feedback selections data for preview/mocked flows.
 * Used when in mocked mode to show pre-populated feedback categories.
 */

import type { Model } from '@/common/api/api.pleased';

/**
 * Create mocked feedback selections for regular feedback
 */
export const createMockedFeedbackSelections = (): Model.FeedbackCategory[] => [
  {
    feedbackSelectionId: 1,
    name: 'Speed',
  },
  {
    feedbackSelectionId: 2,
    name: 'Expertise',
  },
  {
    feedbackSelectionId: 3,
    name: 'Clarity',
  },
  {
    feedbackSelectionId: 4,
    name: 'Resolution',
  },
  {
    feedbackSelectionId: 5,
    name: 'Courtesy',
  },
];

/**
 * Create mocked selected improvements (for pre-selecting some feedback items)
 */
export const createMockedSelectedImprovements = (): string[] => [
  '2', // Expertise
  '4', // Resolution
];
